import React, { useContext, useEffect, useState } from 'react'
// import '../assets/common.css'
import { Button, Card, Col, Flex, Form, Input, List, message, Row, Space, Typography } from 'antd'
import { rtlss_api } from '../helpers/frontEndHelpers'
import { EnvironmentContext } from '../routes/EnvironmentContext'
import useMessage from 'antd/es/message/useMessage'
import { useNavigate } from 'react-router-dom'
// import LicenseKeyInput from '../components/LicenseKeyInput'
// import { rtlss_api } from '../helpers/frontEndHelpers'

const ActivateLicense = () => {
    const { isLocal } = useContext(EnvironmentContext)
    const [form] = Form.useForm()
    const [isLoading, setIsLoading] = useState(false)
    const [messageAPI, contextHolder] = useMessage()
    const navigate = useNavigate()

    // const [licenseKey, setLicenseKey] = useState('')
    // const [isLoading, setIsLoading] = useState(false)
    const formatKey = (value) => {
        return value.replace(/[^A-Z0-9]/gi, '').toUpperCase().match(/.{1,4}/g)?.join('-') || ''
    }
    const handleOnChange = (e) => {
        const formatted = formatKey(e.target.value)
        // setLicenseKey(formatted)
        form.setFieldValue('license', formatted)
        if (formatted.length === 19) {
            form.validateFields()
        }
    }

    const handleOnFinish = (e) => {
        setIsLoading(true)
        // console.log(`Handle on finish: `, e)
        // e = {license: 16shits}
        rtlss_api({ method: 'post', isLocal, data: e, _url: '/activate-license' })
            .then((response) => {
                if (response?.error) {
                    messageAPI.error(response.message)
                } else {
                    navigate('/license-redeem-success', { state: { fromSuccess: true, numberofcalculations: response.data[0].numberofcalculations } })
                    // console.log(response)
                    // messageAPI.success(response.message)
                    // console.log(response.data[0].numberofcalculations)
                }
            })
            .catch((err) => {
                console.log(err)
                messageAPI.error(err.message)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <>
            {contextHolder}
            <Row justify='center' align='middle' >
                <Col >
                    <Flex vertical align='center' style={{ width: '100%' }}>
                        <Typography.Title level={2}>Activate Purchased License here</Typography.Title>
                        <Typography.Paragraph>If you company has already purchased a license, enter the license key below to transfer the corresponding credits to your account. </Typography.Paragraph>
                        <Typography.Paragraph>
                            <List
                                header={<Typography.Text strong>How it works:</Typography.Text>}
                                dataSource={[
                                    `This feature is for license keys purchased through a company's procurement or purchasing department.`,
                                    `After purchase, the license key is sent to your designated contact (e.g., purchaser or admin).`,
                                    `Request the license key internally and enter it here.`,
                                    `The associated credits will be added to your account immediately upon activation.`
                                ]}
                                renderItem={(item) => (
                                    <List.Item>
                                        {item}
                                    </List.Item>
                                )}
                            />

                        </Typography.Paragraph>
                    </Flex>
                </Col>
            </Row>
            <Row justify={'center'} style={{ minHeight: '100vh' }}>
                <Col>
                    <Card>
                        <Form
                            onFinish={handleOnFinish}
                            form={form}>
                            <Space>
                                <Form.Item
                                    label='License Key'
                                    rules={[
                                        { required: true, message: `Please enter license key.` },
                                        {
                                            validator: (_, licenseKey) => {
                                                const pattern = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/;
                                                if (pattern.test(licenseKey)) {
                                                    return Promise.resolve()
                                                } else {
                                                    return Promise.reject(new Error('Invalid license key.'))
                                                }
                                            }
                                        }
                                    ]}
                                    // rules={[{ required: true, message: `Please don't.` }]}
                                    name='license'>
                                    <Input
                                        // value={licenseKey}
                                        onChange={handleOnChange}
                                        rules={[{ required: true, message: 'Please provide a license key.' }]}
                                        style={{ textAlign: 'center' }}
                                        placeholder='XXXX-XXXX-XXXX-XXXX'
                                        maxLength={19}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button loading={isLoading} htmlType='submit' type='primary'>
                                        Activate
                                    </Button>
                                </Form.Item>
                            </Space>

                        </Form>
                    </Card>
                </Col>
            </Row>

        </>
    )
}

export default ActivateLicense
